export default [
    {path: ':crop_id'},
    {path: ':crop_id/add'},
    {path: ':crop_id/edit/:form_id'},
    {path: ':crop_id/inputs/:form_id'},
    {path: ':crop_id/inputs/:form_id/add'},
    {path: ':crop_id/inputs/:form_id/edit/:input_id'},
    {path: ':crop_id/inputs/:form_id/details/:input_id'},
]